//
//

import { mapGetters, mapActions } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import NewApiExposedModal from "@/pages/main/views/Apis/newApiModal/newApiExposedModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { publishAppPermissions, copyToClipboard } from "@/assets/js/appFunc";
import { helpers, required } from "vuelidate/lib/validators";

const validExpName = helpers.regex("validExpName", /^[0-9a-zA-Z '._\s-]+$/); // allows alphanumeric characters and space, dot, dash, underscore, apostrophe

export default {
    name: "ExposedPage",
    components: {
        AQButton, AQMenu, AQInput, NewApiExposedModal, AQEmptyState, AQSearch, AQSkeleton, AQDialog, AQEmptySearch, AQTooltip
    },
    props: {
        value: Boolean,
        skeletonState: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            pageName: "expose",
            showDlg: false,
            drescriptionModel: null,
            typeModel: null,
            urlModel: null,
            search: "",
            showSearch: false,
            resetSelectedData: false,
            showMenu: [],
            apiToDelete: {},
            deleteExposeApi: false,
            exposedNumber: 0,
            apisComputed: false,
            editMode: false,
            selectedItem: null,
            webSocketNotif: false,
            webSocketRenameNotif: false,
            roomEmptyExposed: true,
            currentSession: false,
            renameExposedApiDialog: false,
            exposedApiNewName: "",
            duplicatedExposedApiName: false,
            expApiToRename: {},
            cacheClientIdSecret: {}, // because id, client id, client secret don't change
            dummyCredentials: "************************",
            apisKey: 0,
            searchTrigger: false,
            searchInputTriggered: false,
            showTooltipInfo: false
        };
    },
    validations: {
        exposedApiNewName: {
            required,
            validExpName
        }
    },
    computed: {
        ...mapGetters("apis", ["allExposedApis", "getExposedApiCommitId"]),
        ...mapGetters("diagrams", ["diagramConfigData", "diagramData"]),
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "processList"]),

        apisExposedNumber() {
            return this.allExposedApis ? this.allExposedApis.length : 0;
        },
        filteredAllExposedApis() {
            let apis = [];
            const { query } = this.$route;
            if (query && Object.keys(query).length && query.search && !this.searchInputTriggered) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.searchTrigger = false;
                this.$nextTick(() => {
                    this.searchTrigger = true;
                    this.search = query.search;
                });
            }
            if (this.search) {
                const lowerCaseValue = this.search.toLowerCase();
                apis = this.allExposedApis.filter(item => (item.name || "").toLowerCase().includes(lowerCaseValue));
            } else {
                apis = this.allExposedApis;
            }
            apis.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            return apis;
        },
        isReadOnly() {
            return this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : null;
        },
        errorLabel() {
            let errorMsg;
            if (!this.$v.exposedApiNewName.validExpName) {
                errorMsg = this.$t("api.wrongPatternErr");
            } else if (this.$v.exposedApiNewName.$error) {
                errorMsg = this.$t("api.emptyNameDialog");
            } else if (this.duplicatedExposedApiName) {
                errorMsg = this.$t("api.changeName");
            }
            return errorMsg;
        },
        hasErrors() {
            return !this.$v.exposedApiNewName.validExpName || this.$v.exposedApiNewName.$error || this.duplicatedExposedApiName;
        }
    },
    watch: {
        "$backendWebsocketEvents.state.refreshExposedList": function (value) {
            if (value && this.$route.name === "expose") {
                const { data } = value;
                const eventInfo = data.split(":");
                const itemId = eventInfo[2];
                const actionType = eventInfo[3];
                const actionTypeList = ["update", "persist", "delete", "rename"];
                if (actionTypeList.includes(actionType)) {
                    this.webSocketNotif = false;
                    this.webSocketRenameNotif = false;
                    this.showListUpdate(actionType, itemId);
                }

                this.$backendWebsocketEvents.state.refreshExposedList = false;
            }
        },
        showDlg: {
            handler(newVal) {
                if (newVal && newVal === true && this.selectedItem) {
                    this.$oneAtATime.createRoom("exposed", this.selectedItem.id);
                } else {
                    this.$oneAtATime.destroyCurrentRoom();
                }
                if (newVal && newVal === true && !this.selectedItem) {
                    this.currentSession = true;
                }
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.showPublishBtn();
        this.$root.$on("oneAtATime-exposed", () => {
            this.roomEmptyExposed = this.$oneAtATime.state.$currentRoomEmpty;
        });
        this.$root.$on("oneAtATime-exposed-rename", () => {
            this.$oneAtATime.destroyCurrentRoom();
            const payload = {
                appId: this.currentApp.id,
                id: this.expApiToRename.id,
                name: this.exposedApiNewName
            };
            this.renameExposedApi(payload).then(data => {
                if (this.getExposedApiCommitId !== data.data.commitId) {
                    this.getAllExposedApis();
                }
                this.$store.commit("apis/setExposedApiCommitId", data.data.commitId);
                if (!this.webSocketRenameNotif) {
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("api.websocketCredentialsRenameNotif"),
                        timeout: 2000,
                        icon: "check"
                    });
                }
            });
        });
        this.$root.$on("oneAtATime-exposed-delete", value => {
            if (value === "false") {
                this.resetSelectedData = true;
                setTimeout(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("oneAtATime.uiReadonlyMessage", { user: this.$oneAtATime.state.$currentEditingUser })
                    });
                }, 300);
            } else if (value === "true") {
                this.deleteExposedApi(this.apiToDelete).then(() => {
                    this.showPublishBtn();
                    this.apiToDelete = {};
                    this.showMenu = [];
                    this.resetSelectedData = true;
                    this.$oneAtATime.destroyCurrentRoom();
                },
                () => {
                    this.resetSelectedData = true;
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("api.deleteExpApiError"),
                        timeout: 1000
                    });
                });
            }
        });
    },
    destroyed() {
        this.$root.$off("oneAtATime-exposed");
        this.$root.$off("oneAtATime-exposed-rename");
        this.$root.$off("oneAtATime-exposed-delete");
    },
    deactivated() {
        this.search = "";
        this.searchInputTriggered = false;
    },
    methods: {
        copyToClipboard,
        ...mapActions("apis", ["getAllExposedApis", "deleteExposedApi", "renameExposedApi", "getExposedClientIdSecret"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        headerMenu() {
            return [{
                value: "delete",
                label: this.$t("api.delete")
            },
            {
                value: "rename",
                label: this.$t("api.renameOptionMenu")
            }
            ];
        },
        showListUpdate(action, itemId) {
            this.getAllExposedApis().then(() => {
                this.apisKey += 1;
                if (action === "rename") {
                    const isInEdit = this.allExposedApis.find(el => el.id === itemId);
                    if (isInEdit) {
                        this.$root.$emit("apiRenameExposedDone", { editId: itemId, editNewName: isInEdit.name });
                    }
                }
                if (!this.webSocketNotif && !this.webSocketRenameNotif) {
                    const editedItemDeleted = this.selectedItem && this.selectedItem.id && itemId === this.selectedItem.id ? this.selectedItem : false;
                    if (action === "delete" && !this.currentSession && editedItemDeleted) {
                        if (itemId === this.selectedItem.id) {
                            this.showDlg = false;
                            this.editMode = false;
                            this.selectedItem = null;
                            this.roomEmpty = true;
                            this.$root.$off("startEditing");
                        }
                        this.webSocketNotif = this.$toast.showNotify({
                            type: "info",
                            message: this.$t("api.websocketCredentialsDeletedNameNotif",
                                { name: editedItemDeleted.platformName || editedItemDeleted.name, user: this.$oneAtATime.state.$currentEditingUser }),
                            timeout: 3000
                        });
                    }
                    if (action === "delete" && this.currentSession) {
                        this.webSocketNotif = this.$toast.showNotify({
                            type: "success",
                            message: this.$t("api.websocketCredentialsDeletedNotif"),
                            timeout: 2000,
                            icon: "check"
                        });
                    } else if ((action === "delete" && !this.currentSession && !editedItemDeleted)
                                || (action === "rename" && !this.currentSession)
                                || (action === "persist" && !this.selectedItem && !this.currentSession)
                                || (action === "persist" && this.selectedItem && this.selectedItem.id !== itemId)) {
                        this.webSocketNotif = this.$toast.showNotify({
                            type: "info",
                            message: this.$t("api.websocketCredentialsNotif"),
                            timeout: 2000
                        });
                    }
                }
                this.currentSession = false;
            });
        },
        createNewApi() {
            this.showDlg = true;
            if (!this.editMode) {
                this.roomEmptyExposed = true;
            }
            this.selectedItem = null;
        },
        openEditModal(item) {
            this.showDlg = true;
            this.selectedItem = item;
            this.editMode = true;
        },
        deleteExposed() {
            this.$oneAtATime.createRoom("exposed", this.apiToDelete.id, "delete");
            this.currentSession = true;
        },
        selectedOption($event, item) {
            if ($event[0]) {
                if ($event[0].value === "delete") {
                    this.apiToDelete = { ...item };
                    this.deleteExposeApi = true;
                } else if ($event[0].value === "rename") {
                    this.renameExposedApiDialog = true;
                    this.expApiToRename = { ...item };
                    this.exposedApiNewName = this.expApiToRename.name;
                    this.resetSelectedData = true;
                }
            }
        },
        deleteExposedAction() {
            this.deleteExposed(this.apiToDelete);
        },
        deleteExposedCancel() {
            this.showMenu = [];
            this.$oneAtATime.destroyCurrentRoom();
        },
        changeEdit(val) {
            this.editMode = val;
        },
        renameExpApi() {
            this.duplicatedExposedApiName = !!this.allExposedApis.find(el => el.name === this.exposedApiNewName && el.id !== this.expApiToRename.id);
            if (this.$v.exposedApiNewName.validExpName && !this.$v.exposedApiNewName.$error && !this.duplicatedExposedApiName) {
                this.$oneAtATime.createRoom("exposed", this.expApiToRename.id, "rename");
                this.currentSession = true;
            } else {
                this.renameExposedApiDialog = true;
            }
        },
        resetExposedApiNameValidation() {
            this.duplicatedExposedApiName = false;
            this.$oneAtATime.destroyCurrentRoom();
        },
        toggleCredentials(id, noDisplay) {
            if (this.$refs && this.$refs[`exposedToggle${id}`] && this.$refs[`exposedId${id}`] && this.$refs[`exposedSecret${id}`]) {
                if (this.$refs[`exposedToggle${id}`][0].innerText === this.$t("api.showCredentials")) {
                    if (this.cacheClientIdSecret[id]) {
                        this.$refs[`exposedId${id}`][0].innerText = this.cacheClientIdSecret[id].clientId;
                        this.$refs[`exposedSecret${id}`][0].innerText = this.cacheClientIdSecret[id].secret;
                        this.$refs[`exposedToggle${id}`][0].innerText = this.$t("api.hideCredentials");
                        this.cacheClientIdSecret[id].displayed = true;
                    } else {
                        return new Promise((resolve) => {
                            this.getExposedClientIdSecret(id).then(data => {
                                if (!noDisplay) {
                                    this.$refs[`exposedId${id}`][0].innerText = data.data.clientId;
                                    this.$refs[`exposedSecret${id}`][0].innerText = data.data.secret;
                                    this.$refs[`exposedToggle${id}`][0].innerText = this.$t("api.hideCredentials");
                                }
                                this.cacheClientIdSecret[id] = {
                                    clientId: data.data.clientId,
                                    secret: data.data.secret,
                                    displayed: true
                                };
                                resolve(data);
                            });
                        });
                    }
                } else {
                    this.$refs[`exposedToggle${id}`][0].innerText = this.$t("api.showCredentials");
                    this.$refs[`exposedId${id}`][0].innerText = this.dummyCredentials;
                    this.$refs[`exposedSecret${id}`][0].innerText = this.dummyCredentials;
                    this.cacheClientIdSecret[id].displayed = false;
                }
            }
            return false;
        },
        copyDataToClipboard(id, isClientId) {
            if (isClientId) {
                this.copyToClipboard(this.cacheClientIdSecret[id].clientId);
            } else {
                this.copyToClipboard(this.cacheClientIdSecret[id].secret);
            }
        },
        copyData(id, isClientId) {
            if (this.cacheClientIdSecret[id]) {
                this.copyDataToClipboard(id, isClientId);
            } else {
                this.toggleCredentials(id, true).then(() => {
                    this.copyDataToClipboard(id, isClientId);
                });
            }
        },
        hadCredentialsDisplayed(id) {
            return this.cacheClientIdSecret[id] && this.cacheClientIdSecret[id].displayed && this.cacheClientIdSecret[id].displayed === true;
        },
        showHideCredentials(id) {
            return this.hadCredentialsDisplayed(id) ? this.$t("api.hideCredentials") : this.$t("api.showCredentials");
        },
        credentialsId(id) {
            return this.hadCredentialsDisplayed(id) ? this.cacheClientIdSecret[id].clientId : this.dummyCredentials;
        },
        credentialsSecret(id) {
            return this.hadCredentialsDisplayed(id) ? this.cacheClientIdSecret[id].secret : this.dummyCredentials;
        },
        showPublishBtn() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
                this.$root.$emit("showPublish", {
                    noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses : !this.processList.length,
                    showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions)
                });
            });
        },
        changeSearchUrl(value) {
            const searchText = value.trim();
            const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
            const query = searchText ? { search: searchText } : {};
            this.searchInputTriggered = true;
            if (queriesAreDifferent) {
                this.$router.replace({ path: `/applications/${this.currentApp.id}/integrations/exposedCredentials`, query });
            }
        },
        checkIfEllipsis(ref, index) {
            const { [ref]: el } = this.$refs;
            if (el) {
                this.showTooltipInfo = el[index].scrollWidth > el[index].offsetWidth;
            }
        }
    }
};
